import { Routes } from '@angular/router';


export const routes: Routes = [
  { path: '', loadComponent: () => import('./home/home.component').then(c => c.HomeComponent)},
  { path: 'error', loadComponent: () => import('./error/error.component').then(c => c.ErrorComponent), data: {title: 'Error'}},
  { path: ':eventKey', loadChildren: () => import('./event/event.routes').then(m => m.routes) },
  { path: '**', redirectTo: 'error'},
];
